/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlLevel = "/master/levels";
const urlLevelDeleteMultiple = "/master/levels/delete-multiple";

const state = {
  levels: [],
  pagination: {
    current_page: 1,
    per_page: 50,
    total: 0,
  },
};

const actions = {
  /**
   * getListLevels
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListLevels({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlLevel}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_LEVELS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * createLevel
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async createLevel({ commit }, payload) {
    return await axios.post(urlLevel, payload);
  },

  /**
   * updateLevel
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async updateLevel({ commit }, { id, payload }) {
    return await axios.put(`${urlLevel}/${id}`, payload);
  },

  /**
   * deleteLevel
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteLevel({ commit }, id) {
    return await axios.delete(`${urlLevel}/${id}`);
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlLevelDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_LEVELS(state, data) {
    state.levels = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
